import { theme } from '../../../styles';
import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

type CircularCheckmarkProps = DefaultIconProps & {
  variant?: 'tick' | 'dot' | 'empty';
};

export const CircularCheckmarkIcon = ({
  color = 'foraBlue',
  variant = 'tick',
  width = 60,
  marginLeft,
  marginRight,
  containerSize,
}: CircularCheckmarkProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    {variant === 'tick' ? (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
        <g fill="none" fillRule="evenodd">
          <path
            fill={color === 'foraBlue' ? theme.colors.foraBlue : theme.colors.black}
            d="M22 .5C10.126.5.5 10.126.5 22S10.126 43.5 22 43.5 43.5 33.874 43.5 22 33.874.5 22 .5z"
          />
          <path
            fill={color === 'foraBlue' ? theme.colors.foraBlue : theme.colors.white}
            d="M22 3.5c10.217 0 18.5 8.283 18.5 18.5S32.217 40.5 22 40.5 3.5 32.217 3.5 22 11.783 3.5 22 3.5z"
          />
          <path
            fill={color === 'foraBlue' ? theme.colors.white : theme.colors.black}
            d="M28.51 15.666c.737-.823 2.002-.893 2.824-.156.78.698.883 1.87.265 2.69l-.11.134-9.851 11c-.757.846-2.054.886-2.862.121l-.118-.12-5.148-5.749c-.737-.822-.667-2.087.156-2.824.78-.698 1.955-.672 2.703.032l.12.124 3.659 4.084 8.362-9.336z"
          />
        </g>
      </svg>
    ) : variant === 'dot' ? (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#000"
            d="M7.818 0C3.5 0 0 3.5 0 7.818s3.5 7.818 7.818 7.818 7.818-3.5 7.818-7.818S12.136 0 7.818 0z"
          />
          <path
            fill="#FFF"
            d="M7.818 1.09c3.716 0 6.727 3.013 6.727 6.728 0 3.716-3.011 6.727-6.727 6.727-3.715 0-6.727-3.011-6.727-6.727 0-3.715 3.012-6.727 6.727-6.727z"
          />
          <circle cx="7.818" cy="7.818" r="4" fill="#000" />
        </g>
      </svg>
    ) : (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#C6C6C6"
            d="M7.818 0C3.5 0 0 3.5 0 7.818s3.5 7.818 7.818 7.818 7.818-3.5 7.818-7.818S12.136 0 7.818 0z"
          />
          <path
            fill="#FFF"
            d="M7.818 1.09c3.716 0 6.727 3.013 6.727 6.728 0 3.716-3.011 6.727-6.727 6.727-3.715 0-6.727-3.011-6.727-6.727 0-3.715 3.012-6.727 6.727-6.727z"
          />
        </g>
      </svg>
    )}
  </DefaultIconWrapper>
);
